'use client';

import Link from 'next/link';

import { ServiceAllCapsTitle } from './ServiceAllCapsTitle';

export interface RightColumnItem {
  heading?: string;
  italic?: boolean;
  paragraph: string;
}

export interface WhatWeDoProps {
  boldTitle?: string;
  ctaLink?: string;
  ctaText?: string;
  rightColumnItems?: RightColumnItem[];
  textParagraphs?: string[];
  thinTitle?: string;
}

export function WhatWeDo({
  thinTitle,
  boldTitle,
  textParagraphs = [],
  ctaText,
  ctaLink,
  rightColumnItems = [],
}: WhatWeDoProps) {
  return (
    <div className="relative mx-auto flex w-full max-w-[1328px] flex-col py-12 tablet:flex-row tablet:items-start tablet:px-4 tablet:py-24">
      <div className="relative z-0 order-1 w-full tablet:order-2 tablet:-ml-[197px] tablet:flex-1">
        <div className="pb-4 pl-4 pt-6 tablet:pb-6 tablet:pl-[min(245px,25vw)] tablet:pr-12 tablet:pt-12">
          <ServiceAllCapsTitle title="WHAT WE DO" />
        </div>
        <div className="space-y-4 bg-at px-4 pb-8 pt-6 tablet:space-y-6 tablet:pb-12 tablet:pl-[min(245px,25vw)] tablet:pr-12 tablet:pt-12">
          {rightColumnItems.map((item, index) => (
            <div key={index}>
              {item.heading && (
                <h4 className="mb-2 font-soehne text-serviceSectionHeading font-bold leading-[150%] text-white tablet:mb-3">
                  {item.heading}
                </h4>
              )}
              <p
                className={`font-soehne text-serviceBody font-normal leading-[150%] text-white ${item.italic ? 'italic' : ''}`}
              >
                {item.paragraph}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 order-2 w-full bg-white px-4 py-8 tablet:order-1 tablet:mt-[min(200px,20vw)] tablet:w-full tablet:max-w-[664px] tablet:flex-shrink-0 tablet:px-12 tablet:py-12">
        {thinTitle && (
          <p className="mb-3 font-breit text-serviceThinTitle font-buch leading-[150%] text-at tablet:mb-4">
            {thinTitle}
          </p>
        )}
        {boldTitle && (
          <h3 className="mb-4 font-soehne text-serviceSectionHeading font-bold leading-[150%] text-at tablet:mb-6">
            {boldTitle}
          </h3>
        )}
        {textParagraphs.length > 0 && (
          <div className="mb-6 space-y-3 tablet:mb-8 tablet:space-y-4">
            {textParagraphs.map((paragraph, index) => (
              <p key={index} className="font-soehne text-serviceBody font-normal leading-[150%] text-navy">
                {paragraph}
              </p>
            ))}
          </div>
        )}
        {ctaText && ctaLink && (
          <Link
            href={ctaLink}
            className="inline-block rounded-md bg-[#EB4646] px-5 py-3 font-soehne text-serviceCTAText font-normal leading-tight text-[#FAFAFA] transition-colors hover:bg-[#d63a3a] tablet:px-8 tablet:py-4"
          >
            {ctaText}
          </Link>
        )}
      </div>
    </div>
  );
}
